import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-part10',
  templateUrl: './part10.component.html',
  styleUrls: ['./part10.component.scss']
})
export class part10Component implements OnInit {

  readonly lstText: string[] = [`צהרים טובים חזקי!<br/>
  תודה רבה על התקופה המדהימה- עשית לנו את הקיץץץ <br/>
  <strong>השאלות שלך החכימו אותנו מאוד, למדנו, קפצנו, השתוללנו, <br/>  
  ובעיקר - נהנינו!!! :)</strong>  <br/>
  תכנית מושלמת - הן הרעיון והן הביצוע המדהים לא פחות! <br/> 
  <br/>
  תודה ענקית ושוב תודה  <br/>
  משפחת *** קבוצת דרום סניף נתיבות  `
    ,
    `המשחק “ליל שישי בתשע” בלי טשולנט - עשיתם לנו את השבוע טוב יותר...<br/>
    <strong>היה משחק מדליק, ישבנו כולנו מהופנטים פעורי עיניים ופה ודרוכים לקרב. <br/> 
    היה אחלה משחק, באמת מדליק! </strong> <br/>
    ישבנו, נהננו כמו שצריך.  <br/>
    היה כיף כל רגע. משחק כובש וממכר, החכמנו רבות  <br/>
    והעיקר - ;) העברנו בסיפוק יותר משעה בבידוד.... (שיגמר כבר-----)  <br/>
    עם כזה משחק - מי צריך טשולנט???!  <br/>
    <br/>
    רוב תודות! מחכים לפעם הבאה!  <br/>
    משפחת הופמן, מודיעין עילית  `
    ,
    `תקשיבו שם במערכת...:<br/>
    המשחק מושקע ויזואלית בצורה מדהימה,  <br/>
    השאלות מרתקות ומאתגרות,  <br/>
    הצד הטכני פשוט עובד נפלא.  <br/>
    <strong>אבל המנחה אחראי מאוד מאוד לאוירה הטובה המתח והכיף!!! <br/> 
    חזקי, אלוף! </strong> <br/>
    <br/>
    בני יונדוף <br/> `
    ,
    `חזקי וכל הצוות,<strong> תודה רבה על המשחק הכייפי והממכר!!  </strong><br/>
    אין עליך! עשית לנו את החופש! מקווים להמשיך ולהנות בהמשך    <br/>
    ושתהיה לך הצלחה בהכל!   <br/>
    <br/>
    מאיתנו נעמי, קותי ושמואל ל.  <br/> `]
  constructor() { }

  ngOnInit(): void {
  }

}
